(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lw-balance-cta"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const btn = document.getElementById('lw-balance-cta-btn');
  if (!btn) return;

  function getSectionIds() {
    const ids = new Set();
    document.querySelectorAll('[id^="shopify-section-"]').forEach(s => {
      const id = s.id.replace('shopify-section-', '');
      if (id.toLowerCase().includes('cart')) ids.add(id);
    });
    document.querySelectorAll('cart-drawer-component, cart-items-component').forEach(c => {
      const p = c.closest('[id^="shopify-section-"]');
      if (p) ids.add(p.id.replace('shopify-section-', ''));
    });
    return Array.from(ids);
  }

  function updateSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(id => {
      const html = sections[id];
      if (!html) return;
      const t = document.getElementById('shopify-section-' + id);
      if (!t) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const ns = doc.getElementById('shopify-section-' + id);
      t.innerHTML = ns ? ns.innerHTML : html;
    });
  }

  function openDrawer() {
    const d = document.querySelector('cart-drawer-component');
    if (d && typeof d.open === 'function') { d.open(); return; }
    const t = document.querySelector('[data-cart-drawer-toggle], a[href="/cart"]');
    if (t) t.click();
  }

  btn.addEventListener('click', async function () {
    const orig = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Wird hinzugefügt...';
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: 57224038351235, quantity: 1 }], sections: getSectionIds(), sections_url: window.location.pathname })
      });
      if (!r.ok) throw new Error();
      const cart = await r.json();
      if (cart.sections) updateSections(cart.sections);
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart } }));
      btn.innerHTML = 'Hinzugefügt ✓';
      setTimeout(openDrawer, 250);
    } catch (e) {
      alert('Konnte nicht hinzugefügt werden. Bitte erneut versuchen.');
    } finally {
      setTimeout(() => { btn.disabled = false; btn.innerHTML = orig; }, 1500);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-flow-cta"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const btn = document.getElementById('lw-flow-cta-btn');
  if (!btn) return;

  function getSectionIds() {
    const ids = new Set();
    document.querySelectorAll('[id^="shopify-section-"]').forEach(s => {
      const id = s.id.replace('shopify-section-', '');
      if (id.toLowerCase().includes('cart')) ids.add(id);
    });
    document.querySelectorAll('cart-drawer-component, cart-items-component').forEach(c => {
      const p = c.closest('[id^="shopify-section-"]');
      if (p) ids.add(p.id.replace('shopify-section-', ''));
    });
    return Array.from(ids);
  }

  function updateSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(id => {
      const html = sections[id];
      if (!html) return;
      const t = document.getElementById('shopify-section-' + id);
      if (!t) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const ns = doc.getElementById('shopify-section-' + id);
      t.innerHTML = ns ? ns.innerHTML : html;
    });
  }

  function openDrawer() {
    const d = document.querySelector('cart-drawer-component');
    if (d && typeof d.open === 'function') { d.open(); return; }
    const t = document.querySelector('[data-cart-drawer-toggle], a[href="/cart"]');
    if (t) t.click();
  }

  btn.addEventListener('click', async function () {
    const orig = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Wird hinzugefügt...';
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: 57224038449539, quantity: 1 }], sections: getSectionIds(), sections_url: window.location.pathname })
      });
      if (!r.ok) throw new Error();
      const cart = await r.json();
      if (cart.sections) updateSections(cart.sections);
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart } }));
      btn.innerHTML = 'Hinzugefügt ✓';
      setTimeout(openDrawer, 250);
    } catch (e) {
      alert('Konnte nicht hinzugefügt werden. Bitte erneut versuchen.');
    } finally {
      setTimeout(() => { btn.disabled = false; btn.innerHTML = orig; }, 1500);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-lipodem-support"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Chat-Widgets ausblenden: der Button unten rechts kommt vom global aktiven "Shopify Inbox"
  // App-Embed (nicht Brevo - das lädt hier laut layout/theme.liquid gar nicht erst). App-Embeds
  // werden von Shopify selbst über content_for_header injiziert, oft asynchron nachgeladen und
  // teils an <body> gehängt statt in #MainContent - CSS-Selektoren allein erwischen sie deshalb
  // nicht zuverlässig, daher zusätzlich per JS + MutationObserver + wiederholter Prüfung.
  // WICHTIG: Der frühere Positions-Fallback ("jedes fixierte Element unten rechts ausblenden")
  // wurde entfernt - er hat versehentlich auch die eigene Sticky-Leiste (volle Breite, unten)
  // und den offenen Cart-Drawer (rechts andockend) erwischt und sofort wieder ausgeblendet.
  // Nur noch gezielte Selektoren, keine Positions-Heuristik mehr.
  var chatWidgetSelectors = [
    '#brevo-conversations', '[id*="brevo" i]', '[class*="brevo" i]', 'iframe[src*="brevo" i]',
    '#shopify-chat', '.shopify-chat-button', 'shopify-chat', 'shopify-chat-badge',
    '[id^="shopify-chat"]', '[class*="shopify-chat"]',
    '.chat-widget', '.chat-widget-open-icon', '#chat-widget-container',
    'iframe[title*="chat" i]', 'iframe[id*="chat" i]', 'iframe[src*="chat" i]',
    'iframe[src*="inbox" i]', '[id*="inbox" i]', '[class*="inbox" i]'
  ];
  function hideChatWidgets() {
    chatWidgetSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
    });
  }
  hideChatWidgets();
  new MutationObserver(hideChatWidgets).observe(document.body, { childList: true, subtree: true });
  var chatCheckCount = 0;
  var chatCheckInterval = setInterval(function () {
    hideChatWidgets();
    chatCheckCount++;
    if (chatCheckCount > 20) clearInterval(chatCheckInterval);
  }, 1000);

  // Kundenvideos: Desktop = Inline-Wiedergabe mit Controls, Mobil (<= 1000px) = Vollbild-Modal.
  var rvBoxes = document.querySelectorAll('[data-lw-ls-video]');
  var vModal = document.getElementById('lw-ls-vmodal');
  var vModalVideo = document.getElementById('lw-ls-vmodal-video');
  var vModalClose = document.getElementById('lw-ls-vmodal-close');
  if (rvBoxes.length && vModal && vModalVideo && vModalClose) {
    var rvVideos = [];
    var rvIsMobile = function () { return window.matchMedia('(max-width: 1000px)').matches; };
    var openVModal = function (src, poster) {
      if (poster) { vModalVideo.setAttribute('poster', poster); } else { vModalVideo.removeAttribute('poster'); }
      vModalVideo.src = src;
      vModal.hidden = false;
      document.body.style.overflow = 'hidden';
      vModalVideo.play().catch(function () {});
    };
    var closeVModal = function () {
      vModal.hidden = true;
      document.body.style.overflow = '';
      vModalVideo.pause();
      vModalVideo.removeAttribute('src');
      vModalVideo.load();
    };
    Array.prototype.forEach.call(rvBoxes, function (box) {
      var video = box.querySelector('video');
      var playBtn = box.querySelector('.lw-ls-rvplay');
      if (!video || !playBtn) return;
      rvVideos.push(video);
      playBtn.addEventListener('click', function () {
        if (rvIsMobile()) {
          openVModal(video.getAttribute('src'), video.getAttribute('poster'));
        } else {
          rvVideos.forEach(function (v) { if (v !== video && !v.paused) v.pause(); });
          video.setAttribute('controls', 'controls');
          playBtn.style.display = 'none';
          video.play().catch(function () {});
        }
      });
      video.addEventListener('pause', function () { if (video.currentTime === 0) playBtn.style.display = ''; });
      video.addEventListener('ended', function () {
        playBtn.style.display = '';
        video.removeAttribute('controls');
        video.currentTime = 0;
        video.load();
      });
    });
    vModalClose.addEventListener('click', closeVModal);
    vModal.addEventListener('click', function (e) { if (e.target === vModal) closeVModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !vModal.hidden) closeVModal(); });
  }

  // Weitere Bewertungen: die ersten 6 Karten sind sichtbar, jeder Klick blendet 3 weitere ein.
  // (Karten tragen hidden + .lw-ls-review-card--more; Button verschwindet, wenn alle sichtbar sind.)
  var reviewsMoreBtn = document.getElementById('lw-reviews-more-btn');
  var reviewsGrid = document.getElementById('lw-reviews-grid');
  if (reviewsMoreBtn && reviewsGrid) {
    reviewsMoreBtn.addEventListener('click', function () {
      var hiddenCards = reviewsGrid.querySelectorAll('.lw-ls-review-card--more[hidden]');
      if (!hiddenCards.length) return;
      var batch = Array.prototype.slice.call(hiddenCards, 0, 3);
      batch.forEach(function (card) { card.removeAttribute('hidden'); });
      if (!reviewsGrid.querySelectorAll('.lw-ls-review-card--more[hidden]').length) {
        reviewsMoreBtn.style.display = 'none';
      }
      batch[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  // Herbstangebot: Paket-Auswahl (1/2/3 Monate) aktualisiert Ersparnis-Zeile, Button-Text/-Link
  // und den Link der Sticky-Leiste. Countdown bis 31.10.2026 23:59 (MEZ).
  var tierRadios = document.querySelectorAll('.lw-ls-tier__radio');
  if (tierRadios.length) {
    var tierSave = document.getElementById('lw-tier-save');
    var tierCta = document.getElementById('lw-tier-cta');
    var stickyCta = document.getElementById('lw-sticky-cta');
    var applyTier = function (r) {
      if (tierSave) tierSave.innerHTML = 'Du sparst <strong>' + r.getAttribute('data-save') + '</strong> gegenüber dem Einzelkauf';
      if (tierCta) {
        tierCta.setAttribute('href', r.getAttribute('data-href'));
        tierCta.textContent = 'Jetzt für ' + r.getAttribute('data-total') + ' bestellen →';
      }
      if (stickyCta) stickyCta.setAttribute('href', r.getAttribute('data-href'));
      Array.prototype.forEach.call(tierRadios, function (x) {
        x.closest('.lw-ls-tier').classList.toggle('is-selected', x.checked);
      });
    };
    Array.prototype.forEach.call(tierRadios, function (r) {
      r.addEventListener('change', function () { applyTier(r); });
      if (r.checked) applyTier(r);
    });
  }
  var herbstCd = document.getElementById('lw-herbst-countdown');
  if (herbstCd) {
    var cdTarget = new Date(herbstCd.getAttribute('data-target')).getTime();
    var cdOut = herbstCd.querySelector('[data-cd]');
    var cdPad = function (n) { return (n < 10 ? '0' : '') + n; };
    var cdTick = function () {
      var diff = cdTarget - Date.now();
      if (!(diff > 0)) { herbstCd.hidden = true; return; }
      var d = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5), m = Math.floor(diff % 36e5 / 6e4), sec = Math.floor(diff % 6e4 / 1e3);
      cdOut.textContent = d + ' Tage ' + cdPad(h) + ':' + cdPad(m) + ':' + cdPad(sec);
      herbstCd.hidden = false;
    };
    cdTick();
    setInterval(cdTick, 1000);
  }

  // Cart-Drawer-Komponente bleibt bewusst an ihrem originalen Platz im DOM (innerhalb von
  // #header-group) - kein JS-Umhängen mehr. #header-group wird per CSS mit visibility:hidden
  // (statt display:none) unsichtbar gemacht, und genau der Cart-Drawer bekommt sein
  // visibility:visible gezielt zurück (siehe CSS oben). Dadurch bleibt die interne
  // Custom-Element-Verkabelung (Menge ändern, schließen, Rabattcode, "jetzt kaufen") intakt.

  // Add-to-cart: Bundle-CTAs, die wirklich kaufen (Sticky-Leiste, Kaufblock).
  // Fügt per /cart/add.js hinzu und öffnet danach den echten Cart-Drawer des Themes.
  // Sicherheitsnetz: klappt das sichtbare Öffnen aus irgendeinem Grund nicht, wird zu
  // /cart weitergeleitet, damit der Kauf in jedem Fall abschließbar bleibt.
  document.querySelectorAll('[data-add-to-cart]').forEach(function (button) {
    button.addEventListener('click', async function () {
      const variantId = parseInt(button.getAttribute('data-variant-id'), 10);
      if (!variantId) return;
      const originalText = button.innerHTML;
      button.disabled = true;
      button.innerHTML = 'Wird hinzugefügt...';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (!response.ok) throw new Error();

        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));

        const drawer = document.querySelector('cart-drawer-component');
        let opened = false;
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
          opened = true;
        }

        setTimeout(function () {
          const dialogEl = drawer ? drawer.querySelector('dialog') : null;
          const isVisiblyOpen = dialogEl && dialogEl.hasAttribute('open');
          if (!opened || !isVisiblyOpen) {
            window.location.href = '/cart';
            return;
          }
          button.disabled = false;
          button.innerHTML = originalText;
        }, 350);
      } catch (error) {
        console.error('Add to cart error:', error);
        alert('Das Bundle konnte nicht zum Warenkorb hinzugefügt werden. Bitte versuche es erneut.');
        button.disabled = false;
        button.innerHTML = originalText;
      }
    });
  });

  // Hero-Button "Jetzt Bundle entdecken": scrollt sanft zum Kaufblock.
  document.querySelectorAll('[data-scroll-to]').forEach(function (button) {
    button.addEventListener('click', function () {
      const target = document.getElementById(button.getAttribute('data-scroll-to'));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // Sticky Trust/CTA-Leiste: erscheint erst, wenn man an der Hero-Section vorbeigescrollt
  // ist, und verschwindet wieder, sobald der Kaufblock ("Dein nächster Schritt") erreicht
  // ist, weil dort die echten Kauf-Buttons schon sichtbar sind.
  const stickyBar = document.getElementById('lw-stickybar');
  const hero = document.querySelector('.lw-ls-hero-full');
  const buySection = document.getElementById('lw-buy');
  if (stickyBar && stickyBar.parentElement !== document.body) {
    document.body.appendChild(stickyBar);
  }
  if (stickyBar && hero) {
    const toggleSticky = function () {
      const pastHero = hero.getBoundingClientRect().bottom < 0;
      const reachedBuySection = buySection ? buySection.getBoundingClientRect().top < window.innerHeight * 0.6 : false;
      if (pastHero && !reachedBuySection) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    };
    window.addEventListener('scroll', toggleSticky, { passive: true });
    window.addEventListener('resize', toggleSticky, { passive: true });
    toggleSticky();
  }

  // Scroll-Reveal: weiche, gerichtete Einblend-Effekte (siehe CSS)
  const revealEls = document.querySelectorAll('.lw-ls-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  // Pflanzenpower-Tabs: Balance / Flow
  const tabButtons = document.querySelectorAll('[data-tab-btn]');
  tabButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const target = btn.getAttribute('data-tab-btn');
      document.querySelectorAll('[data-tab-btn]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      document.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === target);
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-praxis-angebot"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Add-to-cart buttons (Varianten-ID kommt aus data-Attribut, NICHT aus Liquid
  // innerhalb dieses Blocks - Liquid wird in {% javascript %} nicht ausgewertet)
  const buttons = [
    document.getElementById('praxis-add-bundle'),
    document.getElementById('praxis-cta-add-bundle')
  ].filter(Boolean);

  buttons.forEach(function (button) {
    button.addEventListener('click', async function () {
      const variantId = parseInt(button.getAttribute('data-variant-id'), 10);
      const originalText = button.innerHTML;
      button.disabled = true;
      button.innerHTML = 'Wird hinzugefügt...';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (!response.ok) throw new Error();
        window.location.href = '/checkout';
      } catch (error) {
        console.error('Checkout error:', error);
        alert('Das Bundle konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
        button.disabled = false;
        button.innerHTML = originalText;
      }
    });
  });

  // Gallery thumbnails
  const mainImage = document.getElementById('praxis-gallery-main');
  document.querySelectorAll('.praxis-product__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.praxis-product__thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImage) mainImage.src = thumb.getAttribute('data-full');
    });
  });

  // Accordion
  document.querySelectorAll('.praxis-acc__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      const panel = document.getElementById(trigger.getAttribute('data-target'));
      const isOpen = trigger.classList.contains('active');

      document.querySelectorAll('.praxis-acc__trigger').forEach(function (t) { t.classList.remove('active'); });
      document.querySelectorAll('.praxis-acc__panel').forEach(function (p) { p.style.maxHeight = null; });

      if (!isOpen) {
        trigger.classList.add('active');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  // Erstes Accordion-Panel initial öffnen
  const firstPanel = document.getElementById('acc-1');
  if (firstPanel) firstPanel.style.maxHeight = firstPanel.scrollHeight + 'px';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-vorteils-bundle"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const button = document.getElementById('lipoway-bundle-scroll');
  const target = document.getElementById('lipoway-bundle-card') || document.getElementById('lipoway-products');

  if (!button || !target) return;

  button.addEventListener('click', function () {
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-vorteils-cta"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const button = document.getElementById('lipoway-add-bundle');

  if (!button) return;

  function getCartSectionIds() {
    const sectionIds = [];

    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (component) {
      const sectionId = component.getAttribute('data-section-id');

      if (sectionId && !sectionIds.includes(sectionId)) {
        sectionIds.push(sectionId);
      }
    });

    return sectionIds;
  }

  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer-component');

    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }

  async function applyDiscountCode(code) {
    try {
      await fetch('/discount/' + encodeURIComponent(code), {
        credentials: 'same-origin'
      });
    } catch (error) {
      console.error('Discount apply error:', error);
    }
  }

  async function addToCart(variantId, button, sourceId) {
    const originalText = button.innerHTML;
    const sectionIds = getCartSectionIds();

    button.disabled = true;
    button.innerHTML = 'Wird hinzugefügt...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: sectionIds.join(','),
          sections_url: window.location.pathname
        })
      });

      if (!response.ok) {
        throw new Error('Produkt konnte nicht hinzugefügt werden.');
      }

      const cart = await response.json();

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: sourceId,
          data: {
            source: 'custom-liquid',
            variantId: String(variantId),
            itemCount: cart.item_count,
            sections: cart.sections
          }
        }
      }));

      button.innerHTML = 'Hinzugefügt';

      requestAnimationFrame(function () {
        setTimeout(function () {
          openCartDrawer();
        }, 120);
      });

    } catch (error) {
      console.error('Cart add error:', error);
      alert('Das Bundle konnte nicht hinzugefügt werden. Bitte versuche es erneut.');

      button.disabled = false;
      button.innerHTML = originalText;
    } finally {
      setTimeout(function () {
        button.disabled = false;
        button.innerHTML = originalText;
      }, 1500);
    }
  }

  button.addEventListener('click', async function () {
    await applyDiscountCode('Bundle-Angebot');
    addToCart(58131177668995, button, 'lipoway-cta');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-vorteils-duo"] && !Shopify.designMode) return;
  try {
    
function lipoDuoInit() {
  const button = document.getElementById('lipo-duo-add-bundle');
  const target = document.getElementById('lipoway-timed-bundle-card')
    || document.getElementById('lipoway-timed-offer')
    || document.getElementById('lipoway-bundle-card')
    || document.getElementById('lipoway-products');

  if (!button || !target) return;

  button.addEventListener('click', function () {
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', lipoDuoInit);
} else {
  lipoDuoInit();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-vorteils-hero"] && !Shopify.designMode) return;
  try {
    
function lipowayHeroInit() {
  const button = document.getElementById('lipoway-hero-add-bundle');
  const target = document.getElementById('lipoway-timed-bundle-card')
    || document.getElementById('lipoway-timed-offer')
    || document.getElementById('lipoway-bundle-card')
    || document.getElementById('lipoway-products');

  if (!button || !target) return;

  button.addEventListener('click', function () {
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', lipowayHeroInit);
} else {
  lipowayHeroInit();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-vorteils-ingredients"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.lipoway-ingredients__trigger').forEach(function(trigger) {

      trigger.addEventListener('click', function() {

        const item = trigger.closest('.lipoway-ingredients__item');
        const content = item.querySelector('.lipoway-ingredients__content');
        const isActive = item.classList.contains('active');

        item.closest('.lipoway-ingredients__accordion')
          .querySelectorAll('.lipoway-ingredients__item')
          .forEach(function(otherItem) {
            otherItem.classList.remove('active');
            otherItem.querySelector('.lipoway-ingredients__content').style.maxHeight = null;
          });

        if (!isActive) {
          item.classList.add('active');
          content.style.maxHeight = content.scrollHeight + 'px';
        }

      });

    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-vorteils-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const bundleButton = document.getElementById('lipoway-products-add-bundle');
  const singleProductButtons = document.querySelectorAll('.lipoway-single-product-btn');

  function getCartSectionIds() {
    const sectionIds = [];

    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (component) {
      const sectionId = component.getAttribute('data-section-id');

      if (sectionId && !sectionIds.includes(sectionId)) {
        sectionIds.push(sectionId);
      }
    });

    return sectionIds;
  }

  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer-component');

    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }

  async function getFirstAvailableVariantId(handle) {
    const response = await fetch('/products/' + handle + '.js');

    if (!response.ok) {
      throw new Error('Produkt konnte nicht geladen werden.');
    }

    const product = await response.json();

    const variant = product.variants.find(function (item) {
      return item.available;
    }) || product.variants[0];

    return variant.id;
  }

  async function addToCart(variantId, button, sourceId) {
    const originalText = button.innerHTML;
    const sectionIds = getCartSectionIds();

    button.disabled = true;
    button.innerHTML = 'Wird hinzugefügt...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: sectionIds.join(','),
          sections_url: window.location.pathname
        })
      });

      if (!response.ok) {
        throw new Error('Produkt konnte nicht hinzugefügt werden.');
      }

      const cart = await response.json();

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: sourceId,
          data: {
            source: 'custom-liquid',
            variantId: String(variantId),
            itemCount: cart.item_count,
            sections: cart.sections
          }
        }
      }));

      button.innerHTML = 'Hinzugefügt';

      requestAnimationFrame(function () {
        setTimeout(function () {
          openCartDrawer();
        }, 120);
      });

    } catch (error) {
      console.error('Cart add error:', error);
      alert('Das Produkt konnte nicht hinzugefügt werden. Bitte versuche es erneut.');

      button.disabled = false;
      button.innerHTML = originalText;
    } finally {
      setTimeout(function () {
        button.disabled = false;
        button.innerHTML = originalText;
      }, 1500);
    }
  }

  if (bundleButton) {
    bundleButton.addEventListener('click', async function () {
      try {
        await addToCart(58131177668995, bundleButton, 'careline-bundle');
      } catch (error) {
        console.error('Bundle add-to-cart error:', error);
      }
    });
  }

  singleProductButtons.forEach(function (button) {
    button.addEventListener('click', async function () {
      const handle = button.getAttribute('data-product-handle');

      try {
        const variantId = await getFirstAvailableVariantId(handle);
        await addToCart(variantId, button, handle);
      } catch (error) {
        console.error('Product load error:', error);
        alert('Das Produkt konnte nicht geladen werden. Bitte versuche es erneut.');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-vorteils-timed-offer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const bundleButton = document.getElementById('lw-offer-add-bundle');
  const singleProductButtons = document.querySelectorAll('.lw-timed-single-btn');
  const offerSection = document.getElementById('lipoway-timed-offer');
  const pkgButtons = offerSection ? offerSection.querySelectorAll('.lw-offer__pkg') : [];
  let selectedVariantId = 58131177668995;
  let selectedCode = '';

  // Herbstangebot: Ende 31.10.2026 23:59 (MEZ)
  const lwHerbstEnd = new Date('2026-10-31T23:59:59+01:00').getTime();
  const lwHerbstActive = Date.now() < lwHerbstEnd;

  function lwPkgPrice(btn) {
    const price = parseInt(btn.dataset.price, 10);
    const herbst = parseInt(btn.dataset.herbst || '0', 10);
    return lwHerbstActive && herbst > 0 ? price - herbst : price;
  }

  if (!lwHerbstActive && offerSection) {
    const eyebrow = offerSection.querySelector('[data-offer-eyebrow]');
    if (eyebrow) eyebrow.textContent = 'WÄHLE DEINEN VORRAT';
  }

  async function lwApplyDiscount(code) {
    if (!code) return;
    try {
      await fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' });
    } catch (error) {
      console.error('Discount apply error:', error);
    }
  }

  function lwEuro(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';
  }

  function lwEuroShort(cents) {
    const val = cents / 100;
    return (Number.isInteger(val) ? String(val) : val.toFixed(2).replace('.', ',')) + '\u00a0€';
  }

  function lwSetText(selector, text) {
    const el = offerSection.querySelector(selector);
    if (el) el.textContent = text;
  }

  function lwSelectPkg(btn) {
    const months = parseInt(btn.dataset.months, 10) || 1;
    const price = lwPkgPrice(btn);
    const compare = parseInt(btn.dataset.compare, 10);

    pkgButtons.forEach(function (b) {
      const active = b === btn;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-checked', active ? 'true' : 'false');
    });

    selectedVariantId = parseInt(btn.dataset.variant, 10);
    selectedCode = lwHerbstActive ? (btn.dataset.code || '') : '';

    lwSetText('[data-offer-total]', lwEuro(price));
    lwSetText('[data-offer-old]', lwEuro(compare));
    lwSetText('[data-offer-month]', lwEuro(Math.round(price / months)));
    lwSetText('[data-offer-save]', lwEuroShort(compare - price));
  }

  pkgButtons.forEach(function (btn) {
    const months = parseInt(btn.dataset.months, 10) || 1;
    const price = lwPkgPrice(btn);
    const compare = parseInt(btn.dataset.compare, 10);
    const monthEl = btn.querySelector('[data-pkg-month]');
    const oldEl = btn.querySelector('[data-pkg-old]');
    if (monthEl) monthEl.textContent = lwEuro(Math.round(price / months));
    if (oldEl) oldEl.textContent = lwEuro(Math.round(compare / months));

    btn.addEventListener('click', function () {
      lwSelectPkg(btn);
    });
  });

  if (pkgButtons.length) {
    lwSelectPkg(offerSection.querySelector('.lw-offer__pkg.is-active') || pkgButtons[0]);
  }

  function getCartSectionIds() {
    const sectionIds = [];

    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (component) {
      const sectionId = component.getAttribute('data-section-id');

      if (sectionId && !sectionIds.includes(sectionId)) {
        sectionIds.push(sectionId);
      }
    });

    return sectionIds;
  }

  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer-component');

    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }

  async function getFirstAvailableVariantId(handle) {
    const response = await fetch('/products/' + handle + '.js');

    if (!response.ok) {
      throw new Error('Produkt konnte nicht geladen werden.');
    }

    const product = await response.json();

    const variant = product.variants.find(function (item) {
      return item.available;
    }) || product.variants[0];

    return variant.id;
  }

  async function addToCart(variantId, button, sourceId) {
    const originalText = button.innerHTML;
    const sectionIds = getCartSectionIds();

    button.disabled = true;
    button.innerHTML = 'Wird hinzugefügt...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: sectionIds.join(','),
          sections_url: window.location.pathname
        })
      });

      if (!response.ok) {
        throw new Error('Produkt konnte nicht hinzugefügt werden.');
      }

      const cart = await response.json();

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: sourceId,
          data: {
            source: 'custom-liquid',
            variantId: String(variantId),
            itemCount: cart.item_count,
            sections: cart.sections
          }
        }
      }));

      button.innerHTML = 'Hinzugefügt';

      requestAnimationFrame(function () {
        setTimeout(function () {
          openCartDrawer();
        }, 120);
      });

    } catch (error) {
      console.error('Cart add error:', error);
      alert('Das Produkt konnte nicht hinzugefügt werden. Bitte versuche es erneut.');

      button.disabled = false;
      button.innerHTML = originalText;
    } finally {
      setTimeout(function () {
        button.disabled = false;
        button.innerHTML = originalText;
      }, 1500);
    }
  }

  if (bundleButton) {
    bundleButton.addEventListener('click', async function () {
      try {
        await lwApplyDiscount(selectedCode);
        await addToCart(selectedVariantId, bundleButton, 'lipoway-timed-offer-bundle');
      } catch (error) {
        console.error('Bundle add-to-cart error:', error);
      }
    });
  }

  singleProductButtons.forEach(function (button) {
    button.addEventListener('click', async function () {
      const handle = button.getAttribute('data-product-handle');

      try {
        const variantId = await getFirstAvailableVariantId(handle);
        await addToCart(variantId, button, handle);
      } catch (error) {
        console.error('Product load error:', error);
        alert('Das Produkt konnte nicht geladen werden. Bitte versuche es erneut.');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
